import { Contain } from '../components/Grid';
import { Level1, Level2, Level3 } from '../components/StyledOl';
import Annex from '../components/Vendor/Annex';
import Audit from '../components/Vendor/Audit';
import ConfidentialityAndDataProtection from '../components/Vendor/ConfidentialityAndDataProtection';
import Definitions from '../components/Vendor/Definitions';
import TermsAndConditions from '../components/Vendor/TermsAndConditions';

const Vendor = () => (
  <Contain data-testid="vendor-component">
    <p>
      These General Terms and Conditions shall be incorporated into the Purchase Order and be
      interpreted as an integral part of the Purchase Order.
    </p>
    <h2>GENERAL TERMS AND CONDITIONS FOR PURCHASE OF GOODS AND/OR SERVICES</h2>
    <Level1>
      <Definitions />
      <li>
        ACCEPTANCE
        <Level2>
          <li>
            The Contractor shall confirm acceptance of these Terms and Conditions either by:
            <Level3>
              <li>
                the Contractor&rsquo;s written acknowledgement of the Purchase Order or the failure
                by the Contractor to notify LINK of the Contractor's non-acceptance of the Purchase
                Order within three (3) working days of the date hereof; or
              </li>
              <li>
                the Contractor&rsquo;s supplying of any or performing any part of the Goods
                /Services specified in the Purchase Order.
              </li>
            </Level3>
          </li>
          <li>
            No alterations, amendments or additions shall be made to these Terms and Conditions upon
            Acceptance, unless agreed in writing. Unless specifically stated in the Purchase Order,
            no other documents such as the Contractor&rsquo;s Delivery Order, Invoice,
            Contractor&rsquo;s general terms and conditions of sale, etc. shall form a part of this
            Contract.&nbsp;LINK shall only be bound by the Contractor&rsquo;s terms and conditions
            provided they are in accordance with LINK&rsquo;s Terms and Conditions.
          </li>
        </Level2>
      </li>
      <TermsAndConditions />
      <li>
        NOTICE OF DEFAULT
        <Level2>
          <li>
            In addition to and without prejudice to any other rights of LINK under this Purchase
            Order , if the Contractor breaches any of the terms and conditions in this Purchase
            Order , LINK may in its absolute discretion, issue a notice of default to the Contractor
            informing the Contractor of its default. The Contractor shall, within seven (7) days of
            the date of the notice of default, remedy the default. If the Contractor fails to do so,
            LINK shall have the right to terminate the Purchase Order or cancel any part thereof by
            way of a notice of termination without LINK being liable therefor in damages or
            compensation. The said termination shall take effect from the date of the notice of
            termination.
          </li>
        </Level2>
      </li>
      <li>
        RIGHT OF TERMINATION
        <Level2>
          <li>
            Without prejudice to LINK&rsquo;s other rights under this Purchase Order , LINK shall be
            entitled to terminate this Purchase Order immediately by written notice to the
            Contractor in the following circumstances:
            <Level3>
              <li>
                if the Contractor commits any breach of the terms and conditions of this Purchase
                Order and fails to remedy the same within a period of seven (7) days from the
                Contractor&rsquo;s receipt of LINK&rsquo;s written notice giving particulars of the
                breach and requiring it to be remedied;
              </li>
              <li>
                any mortgagee, chargee or encumbrancer takes possession or a receiver is appointed
                over any of the property or assets of the Contractor;
              </li>
              <li>
                the Contractor makes any voluntary arrangement with its creditors or becomes subject
                to an administration;
              </li>
              <li>
                an order of court is made to wind up the Contractor or to place it under judicial
                management or a resolution is passed by the members of the Contractor for its
                winding up or liquidation;
              </li>
              <li>
                any distress or execution is levied or enforced in relation to any of the assets of
                the Contractor; or
              </li>
              <li>the Contractor ceases to carry on business or becomes insolvent.</li>
            </Level3>
          </li>
          <li>
            LINK shall be entitled to terminate the Purchase Order in respect of all or part only of
            the Goods and/or Services by providing reasonable sum for and accepted delivery of all
            finished Goods manufactured by the Contractor and any Services rendered up to the date
            of termination. For the avoidance of doubt, LINK may terminate the Purchase Order
            without cause at any time and without being subject to any liability for any damages.
          </li>
        </Level2>
      </li>
      <li>
        CONSEQUENCES OF TERMINATION
        <Level2>
          <li>
            In the event of termination under this Purchase Order for any reason:
            <Level3>
              <li>
                the Contractor shall cease work forthwith or as soon as practicable and without
                undue delay, take such steps that are necessary to bring an end to the Services
                which are terminated and to reduce expenditures to a minimum. LINK shall not be
                obliged to make any payment in respect of or incidental to work which the Contractor
                has not yet proceeded with at the date of termination;
              </li>
              <li>
                the Contractor shall refund to LINK on a pro-rata basis, all payments made in
                advance or previously paid to the Contractor under this Purchase Order for the
                periods for which the relevant Services have not yet been carried out under this
                Purchase Order provided always that such refunds as aforesaid shall not prejudice or
                affect any right of action or remedy which shall have accrued or shall thereafter
                accrue to LINK as a result of the termination of this Purchase Order due to the
                Contractor&rsquo;s breach; and
              </li>
              <li>
                LINK shall have the right to purchase from other sources any part of the Goods which
                is defective at the time of termination or a similar Goods if it remains undelivered
                at the time of termination and similar Services which have not been performed, and
                in the event of termination of this Purchase Order for cause by LINK, any increased
                costs shall be deducted from any moneys due or to become due to the Contractor or
                shall be recoverable as damages.
              </li>
            </Level3>
          </li>
          <li>
            The expiry or earlier termination of this Purchase Order for any reason by any Party
            shall not relieve the Parties of their obligations hereunder including warranties,
            remedies, promises of indemnity and confidentiality (where applicable) which by their
            nature survive such expiration or termination.
          </li>
        </Level2>
      </li>
      <ConfidentialityAndDataProtection />
      <li>
        VARIATION OF TERMS
        <Level2>
          <li>
            No variation whether oral or otherwise in the terms of this Purchase Order shall apply
            thereto unless such variation shall have first been expressly accepted in writing by the
            Contractor and the authorised Purchase Order signatory of&nbsp;LINK.
          </li>
        </Level2>
      </li>
      <li>
        TAXES, FEES AND DUTIES
        <Level2>
          <li>
            The Contractor shall be responsible for all corporate and personal income taxes, customs
            fees, duties, fines, levies, assessments and other taxes payable under the laws
            of&nbsp;Singapore by the Contractor or its employees, in carrying out its obligations
            under the Purchase Order .
          </li>
          <li>
            If LINK receives a request from the tax authorities to pay on behalf of the Contractor
            and/or the Contractor's employees, or to withhold payments from the Contractor in order
            that LINK may subsequently so pay, any of the abovementioned taxes, fees, duties, fines,
            levies and assessments, the Contractor hereby authorises LINK to comply with the terms
            of the said request.
          </li>
        </Level2>
      </li>
      <li>
        GOVERNMENT REGULATIONS
        <Level2>
          <li>
            The Contractor shall, at its own costs, obtain and maintain all licences and
            authorisations, including export licences and permits and other governmental
            authorisations or certification required without any restrictions or qualifications
            whatsoever so as to enable the Contractor to fulfill all its obligations under the
            Purchase Order .
          </li>
        </Level2>
      </li>
      <li>
        INDEMNIFICATION
        <Level2>
          <li>
            The Contractor agrees that it will indemnify and keep indemnified LINK, its officers,
            employees, agents and representatives from and against all claims, cost, damages, debt,
            expense, liability, loss, suit, action, demand, cause of action, proceeding or judgment
            of any kind which are made or brought against or suffered or incurred by LINK and arise
            directly and/or indirectly out of or in connection with any act or omission or otherwise
            in the performance of this Purchase Order by the Contractor.
          </li>
          <li>
            In the event of LINK (including for this purpose every officer and agent thereof) being
            held liable for damages arising out of any claim by any workman or employee employed by
            the Contractor in and for the performance of the Purchase Order , the Contractor shall
            indemnify LINK, its officers or agents against such claim and any costs, charges and
            expenses in respect thereof PROVIDED the same is not caused by the gross negligence or
            willful default of LINK, its officers or agents.
          </li>
        </Level2>
      </li>
      <li>
        APPLICABLE LAW AND DISPUTE RESOLUTION
        <Level2>
          <li>
            This Purchase Order shall be governed by&nbsp;
            <strong>Singaporean</strong>
            &nbsp;law, without regard to the choice or conflicts of law provisions of any
            jurisdiction, and any disputes, actions, claims or causes of action arising out of or in
            connection with this Purchase Order shall be referred to the Singapore International
            Arbitration Centre (&ldquo;
            <strong>SIAC</strong>&rdquo;), in accordance with the Rules of the SIAC as modified or
            amended from time to time (the &ldquo;
            <strong>Rules</strong>&rdquo;) by a sole arbitrator appointed by the mutual agreement of
            the parties (the &ldquo;
            <strong>Arbitrator</strong>&rdquo;). If Parties are unable to agree on an arbitrator,
            the Arbitrator shall be appointed by the President of the SIAC in accordance with the
            Rules. The seat and venue of the arbitration shall be Singapore, in the English language
            and the fees of the Arbitrator shall be borne equally by the Parties, provided that the
            Arbitrator may require that such fees be borne in such other manner as the Arbitrator
            determines is required in order for this arbitration clause to be enforceable under
            applicable law.
          </li>
        </Level2>
      </li>
      <li>
        INTELLECTUAL PROPERTY
        <Level2>
          <li>
            All intellectual property rights in any materials or documents created or commissioned
            by the Contractor for LINK pursuant to and/or for the purpose of delivering the Goods
            and/or performing the Services under this Purchase Order (&ldquo;
            <strong>Commissioned Materials</strong>&rdquo;) (if any) shall belong to LINK.
            Commissioned Materials include scripts, objects, routines, sub-routines, programme
            utilities, file structures, object codes, source codes, coding, designs, graphics and
            content, and shall also include any and all updates and modifications to the foregoing.
          </li>
          <li>
            The Contractor shall do all things necessary to effect the necessary transfer,
            assignment or other assurance for the intellectual property rights in all Commissioned
            Materials to vest in LINK when called upon by LINK to do so. The Contractor further
            warrants that it shall have the authority to effect the necessary transfer, assignment
            or other assurance as aforesaid.
          </li>
          <li>
            Where the Contractor is the owner of any pre-existing intellectual property rights
            included in the production of any of the Commissioned Materials (&ldquo;
            <strong>Contractor&rsquo;s IP</strong>&rdquo;), the Contractor hereby grants to LINK a
            non-exclusive, perpetual, irrevocable, worldwide, royalty-free right and license to use
            the Contractor&rsquo;s IP for LINK&rsquo;s own purposes and/or in connection with
            LINK&rsquo;s business.
          </li>
          <li>
            Where Third Party content comprising pre-existing intellectual property rights is
            included in the production of any of the Commissioned Materials, the Contractor shall
            negotiate a grant of the required usage rights at either no additional charge or
            pre-agreed cost to LINK.
          </li>
        </Level2>
      </li>
      <li>
        COMMUNICATIONS/NOTICES
        <Level2>
          <li>
            All notices or other communications required or permitted to be given or made in
            connection with this Purchase Order shall be in writing in English and delivered
            personally or sent by registered post or courier to the Party at the address set out in
            the Purchase Order or such other address as a Party may substitute from time to time by
            giving notice to the other Party in writing.
          </li>
        </Level2>
      </li>
      <Audit />
    </Level1>
    <Annex />
  </Contain>
);

export default Vendor;
